import { useAtom } from "jotai";

import { tlrTypeAtom } from "@shared/state";

export const useTimeLookbackType = () => {
  return useAtom(tlrTypeAtom);
};
